import { Component, inject } from '@angular/core';
import { ShowComponent } from 'src/app/common/component/show.component';
import { DateService } from 'src/app/common/date.service';
import { OrganizationResponse } from '@/common/models/response.model';
import { Organization } from '@/reservation/reservation.model';
import { EventBusinessIssue } from '../event-business.model';
import { ExchangeRateService } from '@/event-business/exchange-rate.service';

interface ERPCurrencies {
	bankCardCurrencyId: string;
	id: string;
	name: string;
	order: string;
	rate: string;
}

@Component({
	selector: 'app-event-business-issues',
	templateUrl: './event-business-issues.component.html',
	styleUrls: ['./event-business-issues.component.css'],
})
export class EventBusinessIssuesComponent extends ShowComponent {
	id: string = this.route.snapshot.params['id'];
	data: Array<any> = [];
	accounts: Array<any> = [];
	currencies: ERPCurrencies[] = [];
	parameters: any;
	event: any;
	issueSelected;
	organizations: Organization[] = [];
	// public filters;

	protected itemsBeforeDataLoad = 1;
	protected apiUrl = 'drivers';

	private readonly ALLOWED_CURRENCIES_CODES = ['PLN', 'EUR', 'USD', 'GBP', 'CHF', 'CZK'];
	private readonly exchangeRateService = inject(ExchangeRateService);

	protected loadBefore() {
		// let route: ActivatedRoute;
		// this.id = route.snapshot.params['id'];
		this.api.get('/currency', (result, error) => {
			if (error) {
				return;
			}

			this.currencies = this.filterOnlyAllowedCurrencies(result.data);
		});
		this.api.get('/eventBusinessParameters', (result, error) => {
			this.parameters = result.data;
		});
		this.api.get('/tourismEvents/' + this.id + '/', (result, error) => {
			this.event = result.data;
		});
		this.api.get('/companyAccounts', (result, error) => {
			this.accounts = result.data;
		});
		this.bag.get('/organization/?limit=9999&is_oskar=true', (result: OrganizationResponse, error) => {
			this.organizations = result?.results;
		});
		this.loadData();
	}

	protected loadData(): void {
		this.loader.show();
		this.api.get('/eventBusinessIssues?eventBusiness=' + this.id, (result, error) => {
			if (error) {
				this.loader.hide();
				return;
			}
			this.data = this.prepareLoadedData(result.data);
			this.data.forEach((item) => {
				this.changeValue(item.currency, item.id);
			});
			this.loader.hide();
		});
	}

	addPos(): void {
		const data = {
			documentNumber: null,
			date: null,
			due: null,
			value: null,
			settled: null,
			currency: null,
			paymentMethod: null,
			documentType: null,
			editable: true,
			organization: null,
		};

		this.data.push(data);
	}

	save(data) {
		data.editable = false;
		data.organization = Number(data.organization);
		this.loader.show();
		if (data.id) {
			this.objectEdit(data);
			return;
		}
		this.objectAdd(data);
	}

	changeValue(currency: string, id: string): void {
		const currentRow = this.data.find((row) => row.id === id);

		if (!currentRow) {
			this.infobox.error('Nie znaleziono wiersza o podanym ID');
			return;
		}

		this.exchangeRateService
			.calculateCurrency(currency, currentRow)
			.then((result) => this.updateRowValuePln(id, result));
	}

	paymentsOpen(data) {
		this.issueSelected = data;
	}

	paymentsClose(): void {
		this.issueSelected = null;
		this.loadData();
	}

	deleteAskRow(data) {
		this.question.ask('Czy na pewno usunąć?', 'deleteAsk');
		this.questionSubscription = this.question.status.subscribe((result) => {
			if (result.dialogId != 'deleteAsk') {
				return;
			}
			if (!result.result) {
				return;
			}
			this.loader.show();
			this.api.del('/eventBusinessIssues/' + data.id, (result, error) => {
				this.loader.hide();
				if (error) {
					return;
				}
				// Remove this row
				this.data = this.data.filter((obj) => obj != data);
			});
		});
	}

	documentTypeChanged(data) {
		if (!data.date) {
			const date = new DateService();
			data.date = date.now().date;
		}
	}

	private objectAdd(data): void {
		data.eventBusiness = this.id;
		this.api.post('/eventBusinessIssues', data, (result, error) => {
			this.loader.hide();
			if (error) {
				return;
			}
			data.id = result.data;
		});
	}

	private objectEdit(data): void {
		this.api.put('/eventBusinessIssues/' + data.id + '/', data, (result, error) => {
			this.loader.hide();
			if (error) {
				return;
			}
		});
	}

	private filterOnlyAllowedCurrencies(currencies: ERPCurrencies[]): ERPCurrencies[] {
		return currencies.filter((currency) => this.ALLOWED_CURRENCIES_CODES.includes(currency.id.toUpperCase()));
	}

	private updateRowValuePln(id: string, valuePln: number | null): void {
		this.data = this.data.map((row) => (row.id === id ? { ...row, valuePln } : row));
	}

	private prepareLoadedData(data: EventBusinessIssue[]): EventBusinessIssue[] {
		return data.map((row) => ({
			...row,
			valuePln: null,
		}));
	}
}
